import { ResetPasswordForm } from "../containers";
import { LoginLayout } from "../layouts";

const ResetPassword = () => {

    return (

        <div className="p-3">
            <LoginLayout>
                <ResetPasswordForm/>
            </LoginLayout>
        </div>



    )

}


export default ResetPassword;